import { HelpTooltip } from '../ui/HelpTooltip'

export function TargetingTooltip() {
	return (
		<HelpTooltip title="Targeting Modes" ariaLabel="Targeting mode help">
			<div>
				<div className="help-tooltip-item-title">
					Player Based
				</div>
				<p className="help-tooltip-item-description">
					Assign routes to specific player roles (X, Y, Z, etc.)
				</p>
				<div className="help-tooltip-example">
					<span className="help-tooltip-example-text">
						Example: X runs Post, Y runs Corner
					</span>
				</div>
			</div>

			<div>
				<div className="help-tooltip-item-title">
					Alignment Based
				</div>
				<p className="help-tooltip-item-description">
					Assign routes based on player position (leftmost, inside, etc.)
				</p>
				<div className="help-tooltip-example">
					<span className="help-tooltip-example-text">
						Example: Leftmost receiver runs Post, Inside receivers run Curl
					</span>
				</div>
			</div>
		</HelpTooltip>
	)
}
